"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentEncodeParams = void 0;
function isValidStringParam(param) {
    const [, value] = param;
    return typeof value === "string" && value.length > 0;
}
function paramToStringParam([key, value]) {
    return Array.isArray(value) ? [key, value.join(",")] : [key, value];
}
function percentEncodeParams(params) {
    return Object.entries(params)
        .map(paramToStringParam)
        .filter(isValidStringParam)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");
}
exports.percentEncodeParams = percentEncodeParams;
